import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * A key as it appears on the keyboard. Sized in em so it tracks whatever text
 * it sits beside, and never shrinks below legibility inside small labels.
 */
const Kbd = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => (
    <kbd
      ref={ref}
      className={cn(
        'inline-flex h-5 min-w-5 select-none items-center justify-center gap-0.5 rounded border',
        'border-border bg-muted px-1.5 font-sans text-[0.6875rem] font-medium leading-none',
        'text-muted-foreground shadow-[0_1px_0_0_hsl(var(--border))]',
        className,
      )}
      {...props}
    />
  ),
);
Kbd.displayName = 'Kbd';

export { Kbd };
